import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useCrud(resource, label = "Record") {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      setItems(await api.list(resource));
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [resource]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const save = useCallback(
    async (values) => {
      if (values.id) {
        await api.update(resource, values.id, values);
        toast.success(`${label} updated`);
      } else {
        await api.create(resource, values);
        toast.success(`${label} added`);
      }
      await refetch();
    },
    [resource, label, refetch]
  );

  const remove = useCallback(
    async (id, reason) => {
      await api.remove(resource, id, reason);
      toast.success(`${label} deleted`);
      await refetch();
    },
    [resource, label, refetch]
  );

  const patch = useCallback(
    async (id, data, msg) => {
      await api.update(resource, id, data);
      if (msg) toast.success(msg);
      await refetch();
    },
    [resource, refetch]
  );

  return { items, loading, refetch, save, remove, patch };
}
